module.exports = __webpack_public_path__ + "img/drug_enforcement-hotspot-2.1.e9aa7307.png";